import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative',
    checkboxContainer: 'relative flex items-center',
    checkbox: 'hidden',
    label:
      'heading-xs-bold flex-center bg-bg-items-white flex h-10 w-fit cursor-pointer rounded-full px-4 py-2 leading-none font-semibold whitespace-nowrap'
  },
  variants: {
    disabled: { true: {}, false: {} },
    checked: {
      true: {},
      false: {}
    },
    color: { white: {} }
  },
  compoundSlots: [
    {
      slots: ['label'],
      disabled: true,
      class: 'text-inactive group-hover:text-inactive cursor-not-allowed'
    },
    {
      slots: ['label'],
      checked: true,
      class: 'bg-blue-dark hover:bg-blue-dark/80 text-white!'
    },
    {
      slots: ['label'],
      checked: false,
      class: 'hover:bg-blue-light hover:text-secondary-hover'
    },
    {
      slots: ['label'],
      checked: false,
      color: 'white',
      class: 'bg-bg-items-grey hover:bg-blue-light hover:text-secondary-hover'
    }
  ]
});
